import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {catchError, map, Observable, throwError} from 'rxjs';
import {CotacaoVM} from 'src/app/api/model/cotacao-online/cotacaoVM';
import {AppConfigurationService} from '../../../erp/services/base/appConfiguration.service';

@Injectable({
  providedIn: 'root',
})
export class CotacaoService {
  constructor(
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService,
  ) {}

  CarregarPlanosLead(data: CotacaoVM, captchaToken: string): Observable<any> {
    const headers = new HttpHeaders({
      'X-Recaptcha': captchaToken,
    });

    return this.httpClient
      .post<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/Products`, data, {headers})
      .pipe(
        map(response => {
          return response;
        }),

        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  comprarOnline(preLeadId: string, contractProductCompanyId: string, branchCompanyContractId: string): Observable<any> {
    const cleanedPreLeadId = preLeadId.trim();
    const cleanedContractProductCompanyId = contractProductCompanyId.trim();
    const cleanedBranchCompanyContractId = branchCompanyContractId.trim();

    const url =
      `${this.appConfigurationService.apiBaseUrl}/Proposal/CreateProposalFromPreLead` +
      `?preLeadId=${encodeURIComponent(cleanedPreLeadId)}` +
      `&contractProductCompanyId=${encodeURIComponent(cleanedContractProductCompanyId)}` +
      `&branchCompanyContractId=${encodeURIComponent(cleanedBranchCompanyContractId)}`;

    return this.httpClient.post<any>(url, {}).pipe(
      map(response => {
        return response;
      }),
      catchError(err =>
        throwError(() => ({
          message: err.message,
          status: err.status,
        })),
      ),
    );
  }
}
